export default __webpack_public_path__ + "img/ePUHiLNY.37061008.svg";